import React from 'react';
import toolLog from '../../images/tool-logo.png';
import TechseeLogo from '../../images/Techsee_logo_blue.png';
import exit from '../../images/exit.png';
import {RouteComponentProps} from 'react-router-dom';
import {Tag} from '../../configuration/index.config';
import {ProgressBar} from '../../Presentational Components/ProgressBar';
import {ISiaState} from '../../stores/siaStore';
import { inject, observer } from 'mobx-react';
import Profile from './Profile';
import ClassificationFlow from './ClassificationFlow';

interface IHeaderProps{
    mainTitle?:string,
    subTitle?:string,
    isMain?:boolean,
    history? : RouteComponentProps,
    siaStore?: ISiaState,
    classificationFlowIndex? : number
}

const Header = (props: IHeaderProps) => {
    const findLogoToolPotion = () => {
        let className = isMain || classificationFlowIndex > -1 ? 'position-left-center-header' : 'position-left-header';

        className = isProgressBarOpen ? className + ' margin-right-semi-sm' : className;

        return className;

    };
    const {mainTitle, subTitle, isMain, history, classificationFlowIndex = -1} = props;
    const isProgressBarOpen = props!.siaStore && props!.siaStore!.totalImages > 0 && props!.siaStore.mode === Tag.DEFAULT;
    const onExitPage = () => {
        if (props.siaStore && props.siaStore.mode) {
            props.siaStore.mode === Tag.DEBUG ? history.push('/analyze_debug') : history.push('/settings');
        } else {
            history.push('/');
        }
    };
    const findIfProfile = () => {
        if (classificationFlowIndex === -1) {
            return !isMain;
        }

        return classificationFlowIndex > -1;
    };

    return (
        <div id={'header'} className={`${!mainTitle && 'ai-factory-background'}`}>
            {classificationFlowIndex === -1 && <img id='techsee-log' className='main-logo-img' src={TechseeLogo} alt='techSee logo' />}
            {mainTitle && <div id='tool-logo' className={findLogoToolPotion()}>
                <img className='tool-logo-responsive' src={toolLog} alt='techSee-tool-logo' />
                <div>
                    <p className='logo-span'>{mainTitle}</p>
                    <p className='logo-span-small'>{subTitle}</p>
                </div>
            </div>}
            {isMain && <>
                {isProgressBarOpen && <ProgressBar progress={{index: props!.siaStore!.progressImageTagging, total: props!.siaStore!.totalImages, value: 0}} className={'progress-main'}/>}
                <img alt={'exit'} width={'71px'} height={'33px'} className={'position-right-header'} src={exit} id={'exit'} onClick={onExitPage}/>
            </>}
            {classificationFlowIndex > -1 && <ClassificationFlow classificationFlowIndex={classificationFlowIndex} />}
            {findIfProfile() && <Profile {...props}/>}
        </div>
    );
};

export default inject('siaStore')(observer(Header));
